/* eslint-disable @typescript-eslint/no-empty-function */
import Api from "@/components/api/api";
import ToastProvider from "@/hooks/useToastProvider";
import { Input, Spinner } from "@material-tailwind/react";
import React, { useEffect, useState, memo } from "react";
import { GrFormPreviousLink } from "react-icons/gr";
import { getUserData } from "@/redux/slices/userSlices";
import { useSelector } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { ListVoucher } from "@/utils/interface.global";
import DialogRendering from "@/components/dialog";

interface props {
  setVoucherID: React.Dispatch<React.SetStateAction<string | null>>;
  isEdited?: boolean | undefined;
}

const VoucherInfo: React.FC<props> = ({ setVoucherID, isEdited }: props) => {
  const navigate = useNavigate();
  const user = useSelector(getUserData);
  const [searchParams] = useSearchParams();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [dataDetail, setDataDetal] = useState<null | ListVoucher>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [formValue, setFormValue] = useState({
    kh_name: dataDetail?.kh_name,
    kh_phone: dataDetail?.kh_phone,
    kh_email: dataDetail?.kh_email,
    kh_address: dataDetail?.kh_address,
  });
  const handleOpenModal = () => setIsOpenModal(!isOpenModal);

  const fetchDetailVoucher = async () => {
    try {
      setIsLoading(true);
      const voucher_id =
        searchParams.get("voucherID") || searchParams.get("voucherEventID");
      const reqUrl = "/get-one-voucher";
      const voucherCode = ""; //Còn thiếu thằng này
      const params = {
        key: user.key_login,
        user_id: user.id,
        voucher_id: voucher_id,
      };
      const res = await Api.post(reqUrl, params);
      if (!res.data.status) {
        setIsLoading(false);
        return ToastProvider({ type: "error", content: res.data.message });
      }
      setIsLoading(false);
      setDataDetal(res.data.data);
      setFormValue({
        kh_name: res.data.data.kh_name,
        kh_phone: res.data.data.kh_phone,
        kh_email: res.data.data.kh_email,
        kh_address: res.data.data.kh_address,
      });
    } catch (error) {
      ToastProvider({
        type: "error",
        content: "Có lỗi xảy ra trong quá trình tải data. Vui lòng thử lại",
      });
    }
  };

  const handleBackButton = () => {
    setVoucherID(null);
    const eventIDParams = searchParams.get("eventID");
    const activatedTabs = searchParams.get("activatedTabs");
    if (activatedTabs) {
      const options = {
        search: `?activatedTabs=${activatedTabs}${
          eventIDParams ? `&eventID=${eventIDParams}` : ""
        }`,
      };
      navigate(options, { replace: true });
    }
  };

  const handleForm = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };
  const handleEdit = async () => {
    setIsOpenModal(false);
    try {
      setIsLoading(true);
      const reqUrl = "/edit-voucher";
      const params = {
        key: user.key_login,
        user_id: user.id,
        voucher_id: dataDetail?.id,
        kh_name: formValue.kh_name,
        kh_phone: formValue.kh_phone,
        kh_email: formValue.kh_email,
        kh_address: formValue.kh_address,
      };
      const res = await Api.post(reqUrl, params);
      if (!res.data.status) {
        setIsLoading(false);
        setIsOpenModal(true);
        return ToastProvider({ type: "error", content: res.data.message });
      } else {
        setIsLoading(false);
        ToastProvider({ type: "success", content: res.data.message });
      }
    } catch (error) {
      setIsOpenModal(true);
      ToastProvider({
        type: "error",
        content: "Có lỗi xảy ra trong quá trình tải data. Vui lòng thử lại",
      });
    }
  };

  useEffect(() => {
    fetchDetailVoucher();
  }, []);

  return (
    <>
      <div className="voucher-container flex flex-col p-5">
        <div className="cursor-pointer font-bold flex items-center gap-1 hover:cursor-pointer hover:underline">
          <GrFormPreviousLink />
          <span className="text-sm" onClick={handleBackButton}>
            Quay Lại
          </span>
        </div>
        {isLoading ? (
          <div className="flex justify-center items-center gap-8 h-96">
            <Spinner color="red" className="h-12 w-12" />
          </div>
        ) : (
          dataDetail && (
            <>
              <h1 className="text-red-500 font-bold text-center text-xl pt-4 pb-6">
                Phiếu thay dầu: {dataDetail.code_voucher}
              </h1>
              <div className="flex flex-col md:flex-row gap-5 py-4">
                <Input
                  variant="standard"
                  color="gray"
                  label="Mã Cửa Hàng"
                  value={dataDetail.head_code}
                  className="font-semibold text-red-500"
                  readOnly
                />
                <Input
                  variant="standard"
                  color="gray"
                  label="Mã Phiếu Thay Dầu"
                  value={dataDetail.code_voucher}
                  readOnly
                />
              </div>
              <div className="flex flex-col md:flex-row gap-5 py-2">
                <Input
                  variant="standard"
                  color="gray"
                  label="Họ và Tên (Không bắt buộc)"
                  name="kh_name"
                  value={formValue.kh_name}
                  onChange={(e) => handleForm(e)}
                />
                <Input
                  variant="standard"
                  color="gray"
                  label="Điện Thoại (Không bắt buộc)"
                  value={formValue.kh_phone}
                  name="kh_phone"
                  onChange={(e) => handleForm(e)}
                />
              </div>
              <div className="flex gap-5 py-3">
                <Input
                  variant="standard"
                  color="gray"
                  label="Email (Không bắt buộc)"
                  value={formValue.kh_email}
                  name="kh_email"
                  onChange={(e) => handleForm(e)}
                />
              </div>
              <div className="flex gap-5 py-3">
                <Input
                  variant="standard"
                  color="gray"
                  label="Địa Chỉ (Không bắt buộc)"
                  value={formValue.kh_address}
                  name="kh_address"
                  onChange={(e) => handleForm(e)}
                />
              </div>
              <div className="flex gap-5 py-3">
                <Input
                  variant="standard"
                  color="gray"
                  label="Thời Gian Kích Hoạt"
                  className="font-semibold text-green-600"
                  value={dataDetail.time_active}
                  readOnly
                />
              </div>
              {isEdited && (
                <div className="flex justify-center gap-5 py-3">
                  <button
                    className="check-another-activated"
                    onClick={handleOpenModal}
                  >
                    Chỉnh Sửa
                  </button>
                </div>
              )}
            </>
          )
        )}
        <DialogRendering
          handleOpenModal={handleOpenModal}
          isOpenModal={isOpenModal}
          handlerFunc={handleEdit}
        />
      </div>
    </>
  );
};

export default memo(VoucherInfo);
